variantHover();
accordionCustom();
dropDownHover();

function variantHover() {
  const variantImages = document.querySelectorAll(".variant_images ul li");
  variantImages.forEach((variant) => {
    variant.addEventListener("mouseover", (event) => {
      // Get the large image source from the data attribute
      const largeImageSrc = variant.dataset.large;
      // Find the main image element
      const mainImageContainer =
        variant.closest(".variant_images").nextElementSibling;
      const mainImage = mainImageContainer?.querySelector("img");
      // Check if the main image exists before updating
      if (mainImage) {
        mainImage.src = largeImageSrc;
        mainImage.srcset = ""; // Clear srcset if needed
        //console.log(mainImage);
      } else {
        console.warn("Main image not found");
      }

      // Remove 'active' class from all variants
      // variantImages.forEach((item) => {
      //     item.classList.remove('active');
      // });

      // Add 'active' class to the currently hovered variant
      //variant.classList.add('active');
    });
  });
}

function accordionCustom() {
  const items = document.querySelectorAll(".custom-accordion-item");
  items.forEach((item) => {
    item
      .querySelector(".custom-accordion-header")
      .addEventListener("click", () => {
        items.forEach((i) => {
          if (i !== item) {
            i.classList.remove("active");
            i.querySelector(".custom-accordion-toggle").textContent = "+";
          }
        });

        item.classList.toggle("active");
        const toggle = item.querySelector(".custom-accordion-toggle");
        toggle.textContent = item.classList.contains("active") ? "−" : "+";
      });
  });
}

function sizeTabs(productId) {
  console.log(productId);

  if(!localStorage.lastTabClick && !localStorage.lastVariantClick){
    localStorage.setItem('lastTabClick', 'men')
    localStorage.setItem('lastVariantClick', '36')
  }
  
  let sizetabs = document.querySelectorAll("#" + productId + " .size-tabs li");
  let variantRadios = document.querySelectorAll(
    "#" + productId + " variant-selects label"
  );
  
  sizetabs.forEach((item) => {
    item.onclick = (e) => {
      let tabName = e.target.dataset.id;
      let active = document.querySelector("#" + productId + " .active");
      if (active !== null) {
        active.classList.remove("active");
      }
      e.target.classList.add("active");
      localStorage.setItem('lastTabClick', tabName)
      
      variantRadios.forEach((label) => {
        let getSize =
          label.dataset[tabName] || label.previousElementSibling?.value;
        if (getSize == "x" || getSize == "X") {
          label.style.display = "none";
        } else {
          label.style.display = "";
        }
        label.textContent = getSize;
      });
    };
  });

  if(localStorage.lastTabClick == "men"){
    document.querySelectorAll('.size-tabs li')[0].click()
  }else if(localStorage.lastTabClick == "women"){
    document.querySelectorAll('.size-tabs li')[1].click()
  }else if(localStorage.lastTabClick == "uk"){
    document.querySelectorAll('.size-tabs li')[2].click()
  }else if(localStorage.lastTabClick == "eu"){
    document.querySelectorAll('.size-tabs li')[3].click()
  }
  document.querySelector(`.product-form__input input[value="${localStorage.lastVariantClick}"]`).click()
  
}

function sizeGuidTrigger(){
  let id = document.querySelector('.size-guid-link').id
  let target = "";
  console.log(id)
  if(id == "t"){
    target = document.getElementById('popup_tees')
  }else{
    target = document.querySelector('.product-popup-modal__button')
  }
  let btn = document.querySelector('.size-guid-link');
  btn.onclick = (e) => {
    target.click();
  }
}
function pdpPopup(){
  const items = document.querySelectorAll(".product_details_popups ul li");
  const close = document.querySelectorAll('.product_info_popup .svg-wrapper')
  items.forEach((item) => {
    item.addEventListener("click", (event) => {
      const popupId = item.dataset.popup;
      const openState = document.getElementById(popupId)
      openState.setAttribute('open','')
      document.body.classList.add('overflow-hidden')
    });
  });

  if(close.length > 0){
    close.forEach((item) => {
      item.addEventListener("click", (event) => {
        item.parentElement.removeAttribute('open')
        document.body.classList.remove('overflow-hidden')
      });
    })
  }
  
}

document.addEventListener('DOMContentLoaded', function () {
  fetch(routes.cart_url)
    .then(response => response.json())
    .then(cart => {
      if (cart.items.length > 0) {
        loadMiniCartRecommendations(cart.items[0].product_id);
      }
    });
});

function loadMiniCartRecommendations(productId) {
  fetch(window.Shopify.routes.root + `recommendations/products?section_id=product-recommendations-cart&limit=4&product_id=${productId}`)
    .then(response => response.text())
    .then(text => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const recommendations = html.querySelector('.product-recommendations');
      if (recommendations) {
        const container = document.getElementById('MiniCartRecommendations');
        if (container) container.innerHTML = recommendations.innerHTML;
      }
    });
}


function dropDownHover() {
  let sticky = document.querySelector('.shopify-section-header-sticky')
  //sticky.classList.contains('scrolled-past-header')
  document.querySelectorAll('.mega-menu').forEach(menu => {
    let timeout;
    
    menu.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
      menu.setAttribute('open', '');
      if(!sticky.classList.contains('scrolled-past-header')){
        sticky.classList.add('scrolled-past-header')
      }
    });
  
    menu.addEventListener('mouseleave', () => {
      
      timeout = setTimeout(() => {
        menu.removeAttribute('open');
        if(sticky.classList.contains('scrolled-past-header') && scrollY < 50){
          sticky.classList.remove('scrolled-past-header')
        }
      }, 200);
      
    });
    
  });
}

class CustomSwiper extends HTMLElement {
  constructor() {
    super()
    // basic options for all sliders
	const id = this.dataset.section
    let swiper = document.getElementById(this.id);
    let optionsData = swiper.dataset.swiper ? JSON.parse(swiper.dataset.swiper) : {};
	let defaults = {
      spaceBetween: 0,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    };
    let options = {...defaults, ...optionsData};
    setTimeout(()=>{
      new Swiper(swiper, options);
    }, 500)
  }
}
customElements.define('custom-swiper', CustomSwiper);


// ====================================== New PDP popup tabs
let currentTab = null;
function closeCurrentTab() {
    if (currentTab === null) return;
    
    const buttons = document.querySelectorAll('.tab-button');
    const contents = document.querySelectorAll('.tab-content');
    const wrapper = document.querySelector('.tab-content-wrapper');
    
    contents[currentTab].classList.remove('active');
    buttons[currentTab].classList.remove('active');
    buttons[currentTab].querySelector('.tab-icon').textContent = '+';
    wrapper.classList.remove('has-active');
    currentTab = null;
}

function closeTab() {
    closeCurrentTab();
}

function switchTab(index) {
    const buttons = document.querySelectorAll('.tab-button');
    const contents = document.querySelectorAll('.tab-content');
    const wrapper = document.querySelector('.tab-content-wrapper');

    // Toggle if same tab clicked
    if (currentTab === index) {
        closeCurrentTab();
        return;
    }

    // Close current tab if open
    if (currentTab !== null) {
        contents[currentTab].classList.remove('active');
        buttons[currentTab].classList.remove('active');
        buttons[currentTab].querySelector('.tab-icon').textContent = '+';
    }

    // Open new tab
    wrapper.classList.add('has-active');
    contents[index].classList.add('active');
    buttons[index].classList.add('active');
    buttons[index].querySelector('.tab-icon').textContent = '−';
    currentTab = index;
}